'use client';

import { useEffect } from 'react';
import { reportClientError } from '@/lib/report-client-error';

export default function GamesError({ error, reset }: { error: Error; reset: () => void }): JSX.Element {
  useEffect(() => {
    // eslint-disable-next-line no-console
    console.error('games route error', error);
    reportClientError(error);
  }, [error]);
  return (
    <section className="border border-border rounded-lg bg-panel p-6 text-sm">
      <h2 className="text-base font-semibold text-err">Something went wrong</h2>
      <p className="mt-2 text-muted">
        We couldn&apos;t render the games list. The executor may be temporarily unreachable.
      </p>
      <button
        onClick={reset}
        className="mt-4 rounded-md border border-accent px-3 py-1 text-xs text-accent hover:bg-accent/10"
      >
        Try again
      </button>
    </section>
  );
}
